import React from 'react'
import {
  SimpleSelect,
  Prompt,
  AutocompleteSelect,
  StepContent
} from '../components'
import companySizes from '../data/company-sizes'
import makeStyles from '@mui/styles/makeStyles'
import industries from '../data/industries'
import { TextField } from '@mui/material'

const useStyles = makeStyles(({ spacing }) => ({
  industries: {
    marginBottom: spacing(4)
  },
  other: {
    marginBottom: spacing(4)
  }
}))

const Step2Content = ({ data, onChange }) => {
  const classes = useStyles()

  const handleOtherChange = ({ target: { value } }) => {
    onChange({ data: 'industryOther', value })
  }

  return (
    <StepContent>
      <Prompt
        prompt='What industry do you work in?'
        data-test='lpq-step2-industry-prompt'
      />
      <AutocompleteSelect
        options={industries}
        value={data.industry || null}
        onChange={value => onChange({ data: 'industry', value })}
        fullWidth
        autoFocus
        disabled={!!data.industryOther}
        placeholder='Select Industry'
        classes={{ root: classes.industries }}
        data-test='lpq-step2-industry-select'
      />
      <Prompt
        prompt='Other industry'
        data-test='lpq-step2-industry-other-prompt'
      />
      <TextField
        value={data.industryOther || ''}
        onChange={handleOtherChange}
        disabled={!!data.industry}
        placeholder='Enter Industry'
        fullWidth
        className={classes.other}
        data-test='lpq-step2-industry-other-input'
      />
      <Prompt
        prompt='How many people are employed at your company?'
        data-test='lpq-step2-company-prompt'
      />
      <SimpleSelect
        options={companySizes}
        value={data.companySize || null}
        onChange={value => onChange({ data: 'companySize', value })}
        aria-label='company-size'
        data-test='lpq-step2-company'
      />
    </StepContent>
  )
}

export default Step2Content
